
import React, { useState } from 'react'
import { Search } from 'react-feather'
import Box from './Box'
import './QueryInput.css'

/**
 * QueryInput component.
 */

export default function QueryInput({ value = '', ...props }) {
  const [focus, setFocus] = useState(false)
  const empty = value.trim() == '' 

  const classes = [
    'QueryInput',
    'IconInput',
    empty && 'empty',
    focus && 'focus'
  ]

  const { marginRight, ...rest } = props

  return <Box classes={classes} marginRight={marginRight} flex>
    <Box className="icon">
      <Search />
    </Box>

    <input
      type="search"
      className="Input"
      placeholder="Search"
      autoComplete="off"
      spellCheck={false}
      onFocus={_ => setFocus(true)}
      onBlur={_ => setFocus(false)}
      value={value}
      {...rest} />
  </Box>
}
